export const nullPromise = new Promise<any>(() => {})
export const zeroInstantString = '1900-01-01T00:00:00Z'
